'use strict';

var WebglMapActions = function WebglMapActions (Flux, APP_DISPATCHER_ID) {

  var Actions = Flux.Actions.create('WebglMapActions', APP_DISPATCHER_ID);
  //
  // Actions.add({
  //   name: 'ValidPointCloudPresent',
  //   purpose: 'If a datacapture has point cloud data in it',
  //   payload: ['data']
  // });

  return Actions;
};

WebglMapActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = WebglMapActions;



// WEBPACK FOOTER //
// ./src/app/dash/webglMap/WebglMapActions.js